import { c as _c } from "react/compiler-runtime";
import type { Time } from '@morpho-org/morpho-ts';
import { Select } from '@morpho-org/ui-v6/client';
import { SegmentedControlItem, SegmentedControlList, Tabs } from '@repo/ui';
import type { TimeFrameOption } from '@/config/table';
interface ChartControlsProps {
  currency: string;
  currencyOptions: Array<{
    value: string;
    label: string;
  }>;
  onCurrencyChange: (currency: string) => void;
  timeFrame: Time.PeriodLike | null;
  onTimeFrameChange: (timeFrame: Time.PeriodLike | null) => void;
  timeFrameOptions: TimeFrameOption[];
}
export function ChartControls(t0) {
  const $ = _c(20);
  const {
    currency,
    currencyOptions,
    onCurrencyChange,
    timeFrame,
    onTimeFrameChange,
    timeFrameOptions
  } = t0;
  let t1;
  if ($[0] !== currency || $[1] !== currencyOptions || $[2] !== onCurrencyChange) {
    t1 = <div className="md:hidden"><Select options={currencyOptions} value={currency} onChange={onCurrencyChange} /></div>;
    $[0] = currency;
    $[1] = currencyOptions;
    $[2] = onCurrencyChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== currencyOptions) {
    t2 = currencyOptions.map(_temp);
    $[4] = currencyOptions;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <SegmentedControlList size="default" aria-label="Currency">{t2}</SegmentedControlList>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== currency || $[9] !== onCurrencyChange || $[10] !== t3) {
    t4 = <div className="max-md:hidden"><Tabs value={currency} onValueChange={onCurrencyChange}>{t3}</Tabs></div>;
    $[8] = currency;
    $[9] = onCurrencyChange;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== onTimeFrameChange || $[13] !== timeFrame || $[14] !== timeFrameOptions) {
    t5 = <Select options={timeFrameOptions} value={timeFrame} onChange={onTimeFrameChange} />;
    $[12] = onTimeFrameChange;
    $[13] = timeFrame;
    $[14] = timeFrameOptions;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t1 || $[17] !== t4 || $[18] !== t5) {
    t6 = <div className="gap-sm flex flex-wrap items-center">{t1}{t4}{t5}</div>;
    $[16] = t1;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp(option) {
  return <SegmentedControlItem key={option.value} value={option.value}>{option.label}</SegmentedControlItem>;
}